import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e8050882&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8050882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8050882')) {
      api.createRecord('e8050882', component.options)
    } else {
      api.reload('e8050882', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e8050882&scoped=true&", function () {
      api.rerender('e8050882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/train/trainPreset/index.vue"
export default component.exports